import {observable, computed} from 'mobx';

import {BaseViewModel} from "../../../infrastructure/models/base-view-model";

export class ScoreboardWidgetScoreCellViewModel extends BaseViewModel {
  @observable _score: Number;
  @observable extraScore: Number;
  @observable isWinner: Boolean;
  @observable isLive: Boolean;
  isMainScore: Boolean;

  constructor(score: Number, extraScore: Number, isWinner: Boolean, isMainScore: Boolean, isLive: Boolean) {
    super();

    this._score = score;
    this.extraScore = extraScore;
    this.isWinner = isWinner;
    this.isMainScore = isMainScore;
    this.isLive = isLive;
  }

  @computed get score(): String {
    const hasScore: Boolean = this._score > -1;
    const score: String = hasScore ? this._score : '-';

    return score;
  }
}